export default __webpack_public_path__ + "static/member-2c7ccfd7e4581367d6d7761f1a4486cf.jpg";